var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic:round-lock"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.0001 5.33329H11.3334V3.99996C11.3334 2.15996 9.84008 0.666626 8.00008 0.666626C6.16008 0.666626 4.66675 2.15996 4.66675 3.99996V5.33329H4.00008C3.26675 5.33329 2.66675 5.93329 2.66675 6.66663V13.3333C2.66675 14.0666 3.26675 14.6666 4.00008 14.6666H12.0001C12.7334 14.6666 13.3334 14.0666 13.3334 13.3333V6.66663C13.3334 5.93329 12.7334 5.33329 12.0001 5.33329ZM8.00008 11.3333C7.26675 11.3333 6.66675 10.7333 6.66675 9.99996C6.66675 9.26663 7.26675 8.66663 8.00008 8.66663C8.73342 8.66663 9.33342 9.26663 9.33342 9.99996C9.33342 10.7333 8.73342 11.3333 8.00008 11.3333ZM6.00008 5.33329V3.99996C6.00008 2.89329 6.89341 1.99996 8.00008 1.99996C9.10675 1.99996 10.0001 2.89329 10.0001 3.99996V5.33329H6.00008Z",
    fill: "#959595"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.cd66aca73cd13c35a3569bdbf59ec2ff.svg";
export { ForwardRef as ReactComponent };